import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IEvaluators } from "app/models/core/home/evaluators";
import { IProficiencyResult } from "app/models/core/lab/proficiency";
import { LabService } from "app/services/lab/lab.service";



@Component({
  selector: 'editProficiencyResult',
  templateUrl: './editProficiencyResult.component.html',
})

export class EditProficiencyResultComponent implements OnInit {

  public yr = 0;
  public period = 1;
  public result: IProficiencyResult;
  private profId: number = 0;
  public eval: IEvaluators[];
  public newResult = false;

  public form = new UntypedFormGroup({
    ProfResId: new UntypedFormControl(0),
    Year: new UntypedFormControl(0),
    Period: new UntypedFormControl(''),
    PtResults: new UntypedFormControl(''),
    PtPercent: new UntypedFormControl(100, [Validators.min(0), Validators.max(100)]),
    Comments: new UntypedFormControl('', [Validators.maxLength(4000)]),
    DateCreated: new UntypedFormControl(''),
    CreatedBy: new UntypedFormControl(''),
    LastUpdated: new UntypedFormControl(''),
    UpdatedBy: new UntypedFormControl(''),
    ProfId: new UntypedFormControl(0),
    Evaluator: new UntypedFormControl('')
  });

  constructor(private fb: UntypedFormBuilder,
    private labService: LabService,
    private dialogRef: MatDialogRef<EditProficiencyResultComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.yr = data.year;
    this.period = data.per;
    this.result = data.proficiency;
    this.profId = data.profId;

    if (data.proficiency == null) {
      this.result = {
        profResId: 0,
        year: this.yr,
        period: this.period.toString(),
        ptResults: "",
        ptPercent: 100,
        comments: "",
        dateCreated: "",
        createdBy: "",
        lastUpdated: "",
        updatedBy: "",
        profId: this.profId,
        evaluator: ""
      };
      this.newResult = true;
    }
    this.form.patchValue({
      ProfResId: this.result.profResId,
      Year: this.result.year,
      Period: this.result.period,
      PtResults: this.result.ptResults,
      PtPercent: this.result.ptPercent,
      Comments: this.result.comments,
      DateCreated: this.result.dateCreated,
      CreatedBy: this.result.createdBy,
      LastUpdated: this.result.lastUpdated,
      UpdatedBy: this.result.updatedBy,
      ProfId: this.result.profId,
      Evaluator: this.result.evaluator
    })

  }

  ngOnInit(): void {
    this.getEvaluators();
    this.form.controls['Year'].disable();
    this.form.controls['Period'].disable();
  }

  getEvaluators() {
    this.labService.getEvaluators().subscribe(
      res => {
        this.eval = res;
      },
      error => console.log('error: ', error),
      () => {
      }
    );
  }

  save(): void {
    let res = this.form.value;
    if (this.form.valid){
      this.result.ptPercent = +this.form.controls['PtPercent'].value;
      this.result.ptResults = this.form.controls['PtResults'].value;
      this.result.comments = this.form.controls['Comments'].value;
      this.result.evaluator = this.form.controls['Evaluator'].value;
      this.labService.savePtResult(this.result).subscribe(
        () => {
          this.dialogRef.close(this.result);
        },
        error => console.log('error: ', error),
        () => {
        }
      );  
    }
  }

  delete(): void {
    if (confirm('Delete Pt Result. Continue?')) {
      this.labService.deletePtResult(this.result.profResId).subscribe(
        () => {
          this.dialogRef.close(this.result);
        },
        error => console.log('error: ', error),
        () => {
        });
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}